// extracted by mini-css-extract-plugin
export default {"cls1":"UserTaggingPingBodyStyles-cls1__e6d7efd1c270d5441baf","cls2":"UserTaggingPingBodyStyles-cls2___35bf05d39b6ca5d3028 UserTaggingPingBodyStyles-cls1__e6d7efd1c270d5441baf"};